import { jsonSchema, relayUnknownSchema } from './schema.js';
import { AsyncSocket } from './async-socket.js';
/** Barebones relay client that deals directly with relay messages. */
class Relay {
    constructor(socket) {
        /** Relay's internal WebSocket connection. */
        Object.defineProperty(this, "socket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.socket = socket;
    }
    /**
     * Get relay messages in an async iterable.
     * It goes on forever until the socket closes or the signal is aborted.
     *
     * @example
     * ```ts
     * for await (const msg of relay.stream(controller.signal)) {
     *   switch(msg[0]) {
     *     case 'EOSE':
     *       controller.abort();
     *       break;
     *     case 'EVENT':
     *       handleEvent(msg[2]);
     *       break;
     *   }
     * }
     * ```
     */
    async *stream(signal) {
        const messages = AsyncSocket.messages(this.socket, signal);
        for await (const { data } of messages) {
            const result = jsonSchema.pipe(relayUnknownSchema).safeParse(data);
            if (result.success) {
                yield result.data;
            }
        }
    }
    /** Send a Nostr message to the relay. If the relay isn't open yet, it will be opened. */
    send(msg) {
        const data = JSON.stringify(msg);
        return AsyncSocket.send(this.socket, data);
    }
    /**
     * Close the connection to the relay. This closes the socket.
     * Once closed, it cannot be reopened without creating a new `Relay` instance.
     */
    close(code, reason) {
        return AsyncSocket.close(this.socket, code, reason);
    }
}
export { Relay };
